var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-schema-antd-tabs" }, [
    _c("div", { staticClass: "ui-schema-antd-tabs-top-bar" }, [
      _c(
        "div",
        { staticClass: "ui-schema-antd-tabs-nav-container" },
        _vm._l(_vm.tabList, function (tab) {
          return _c(
            "div",
            {
              key: tab.key,
              staticClass: "ui-schema-antd-tabs-tab",
              class: {
                "ui-schema-antd-tabs-tab-active": _vm.activeTab === tab.key,
              },
              on: {
                click: function ($event) {
                  return _vm.switchTab(tab.key)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(tab.label) + "\n      ")]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }